module.exports = __webpack_public_path__ + "img/3d-modeling.9c108700.png";